import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';

class SettingsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			
		}
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-cogs"></i>&nbsp; Settings</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item active">
				<Link to="/settings/institutionview" className="nav-link" >Institution Details</Link>
			  </li>
			  <li className="nav-item active">
				<Link to="/settings/academic" className="nav-link" >Academic Details</Link>
			  </li>
			   <li className="nav-item active">
				<Link to="/student/leaveentry" className="nav-link" >Leave Entry</Link>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default SettingsPage;


// WEBPACK FOOTER //
// ./src/views/SettingsPage/SettingsPage.js